import React from 'react';
import { IonContent, IonInfiniteScroll, IonInfiniteScrollContent, IonPage, IonRefresher, IonRefresherContent } from '@ionic/react';
import { useIonRouter } from '@ionic/react';
import { Rate } from 'antd';
import { RouteComponentProps } from 'react-router';
import { Empty, Header } from 'components';
import { axius, types } from 'utils';

const limit = 6;
let refresher: any = null;
let infinitScroller: any = null;

interface Props extends RouteComponentProps, types.StateProps { };
const Ratings: React.FC<Props> = props => {

    const router = useIonRouter();

    const [step, setStep] = React.useState(1);
    const [data, setData] = React.useState<types.Order[]>([]);
    const [total, setTotal] = React.useState(0);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        getData(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getData = (stap: number = step) => {
        setStep(stap);
        !infinitScroller && setLoading(true);
        axius.get(`orders`, {
            cursor: `${((stap - 1) * limit)}-${limit}`,
            status: types.OrderStatus.COMPLETED,
        }).then((res: types.AxiusResponse) => {
            setTotal(res.status === 200 ? res.count : 0);
            if (res.status === 200) {
                if (stap > 1) {
                    let newData = JSON.parse(JSON.stringify(data));
                    newData = newData.concat(res.data);
                    setData(newData);
                } else {
                    setData(res.data);
                }
            } else {
                setData([]);
            }
            setLoading(false);
            refresher && refresher.detail.complete();
            infinitScroller && infinitScroller.target.complete();
        });
    }

    const openOrder = (row: types.Order) => {
        props.dispatch(props.changeData('order', row));
        setTimeout(() => {
            router.push(`/orders/${row.uuid}`);
        }, 300);
    }

    return (
        <IonPage id="Ratings">
            <Header {...props} title="Ratings" />

            <IonContent fullscreen={false}>
                <IonRefresher slot="fixed" onIonRefresh={(e) => {
                    refresher = e;
                    getData(1);
                }}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <div className="p-4">
                    <div className="p-3 text-center fw-600 title mb-4">
                        <span className="secondary">YOUR</span> <span className="text-white">RATINGS</span>
                    </div>

                    {loading && [1, 2, 3, 4, 5, 6].map(i => (
                        <div className="px-4s" key={i}>
                            <div className="skeleton mb-3" style={{ height: 110, borderRadius: 7 }} />
                        </div>
                    ))}

                    {!loading && data.length === 0 && (
                        <Empty style={{}} text="You have not been rated yet" subText="" />
                    )}

                    {!loading && data.length > 0 && data.map((row, i: number) => {
                        const review = row.reviews[0];
                        return (
                            review?.deliveryRate && (
                                <div key={row.uuid} onClick={() => openOrder(row)}>
                                    <div className="fw-500">{review.user.name}</div>
                                    <div className="mb-2">{row.address.name}</div>
                                    <Rate disabled defaultValue={review.deliveryRate} />
                                    {data.length > (i + 1) && (
                                        <div className="divider secondary my-3" />
                                    )}
                                </div>
                            )
                        )
                    })}

                    {!loading && total > limit && (
                        <IonInfiniteScroll
                            onIonInfinite={(e) => {
                                infinitScroller = e;
                                getData(step + 1);
                            }}
                        >
                            <IonInfiniteScrollContent></IonInfiniteScrollContent>
                        </IonInfiniteScroll>
                    )}
                </div>
            </IonContent>
        </IonPage>
    );
}

export default Ratings;